<template>
    <div class="v-upload">
        <uploadSelect
                :type="type"
                :disabled="disabled"
                :max-limit="maxLimit"
                :is-auto="autoUpload"
                :accept="acceptType"
                :is-multiple="isMultiple"
                :file-list="fileList"
                :lastest-file="lastestFile"
                :show-progress="showProgress"
                :enable-head-image="enableHeadImage"
                @on-file-change="onFileChange"
                @on-confirm-upload="uploadFile"
                @on-delete-file="onDeleteFile"
                @on-set-head-image="onSetHeadImage"
        >
        </uploadSelect>
        <slot name="tips"></slot>
        <uploadList
                :file-list="fileList"
                :disabled="disabled"
                :show-file-list="showFileList"
                :show-progress="showProgress"
                @on-delete-file="onDeleteFile"
        ></uploadList>
    </div>
</template>

<script>
    import uploadList from './upload-list'
    import uploadSelect from './upload-select'

    export default {
        name: 'custom-upload',
        components: {
            uploadSelect,
            uploadList
        },
        props: {
            type: {
                type: String,
                default: 'fileList' // fileList or drag or imageList
            },
            disabled: {
                type: Boolean,
                default: false
            },
            url: {
                type: String,
                require: true
            },
            accept: {
                type: String
            },
            isAuto: {
                type: Boolean,
                default: true
            },
            isMultiple: {
                type: Boolean,
                default: false
            },
            maxLimit: {
                type: Number
            },
            thumbnailMode: {
                type: Boolean,
                default: false
            },
            showFileList: {
                type: Boolean,
                default: true
            },
            showProgress: {
                type: Boolean,
                default: true
            },
            defaultFileList: {
                type: Array,
                default () {
                    return []
                }
            },
            fileName: {
                type: String,
                default: 'file'
            },
            params: {
                type: Object,
                default () {
                    return {}
                }
            },
            withCredentials: {
                type: Boolean,
                default: true
            },
            headers: {
                type: Object,
                default () {
                    return {}
                }
            },
            fileLimitSize: {
                type: Number
            },
            enableHeadImage: {
                type: Boolean,
                default: false
            }
        },
        data () {
            return {
                fileList: [],
                lastestFile: {}
            }
        },
        computed: {
            autoUpload () {
                return !(!this.isAuto && this.type === 'fileList')
            },
            acceptType () {
                return this.thumbnailMode ? 'image/gif, image/png, image/jpeg, image/bmp, image/webp' : this.accept
            }
        },
        watch: {
            defaultFileList: {
                immediate: true,
                handler (fileList) {
                    const _fileList = this.fileList = []
                    fileList.forEach(file => {
                        file.id = Math.random().toString(36).substr(2)
                        file.percentage = 100
                        _fileList.push(file)
                    })
                    this.lastestFile = _fileList[_fileList.length - 1]
                }
            }
        },
        methods: {
            initFile (file) {
                file.id = Math.random().toString(36).substr(2)
                try {
                    file.url = URL.createObjectURL(file)
                } catch (err) {
                    console.error(err)
                    return
                }
                const _file = {
                    name: file.name,
                    size: file.size,
                    percentage: 0,
                    id: file.id,
                    showProgress: false,
                    url: file.url,
                    file: file
                }
                return _file
            },
            uploadFile (files) {
                let uploadFiles = this.autoUpload ? files : this.fileList
                if (uploadFiles.length === 0) {
                    return
                } else {
                    if (!this.isMultiple) {
                        uploadFiles = uploadFiles.slice(0, 1)
                    }
                    if (this.autoUpload) {
                        uploadFiles.forEach(file => {
                            this.upload(file)
                        })
                    } else {
                        uploadFiles
                            .filter(file => file.percentage < 100)
                            .forEach(item => {
                                this.upload(item.file)
                            })
                    }
                }
            },
            onFileChange (files) {
                const _fileList = this.fileList
                files = Array.from(files)
                if (files.length > this.maxLimit || _fileList.length >= this.maxLimit) {
                    this.$emit('on-max-limit')
                    return
                }
                if (this.fileLimitSize) {
                    for (let i = 0; i < files.length; i++) {
                        if (files[i].size > this.fileLimitSize) {
                            this.$emit('on-file-size-max-limit')
                            return
                        }
                    }
                }
                files.forEach(file => {
                    const _file = this.initFile(file)
                    _fileList.push(_file)
                })
                this.lastestFile = _fileList[_fileList.length - 1]
                if (this.autoUpload || this.type === 'drag' || this.type === 'imageList') {
                    this.uploadFile(files)
                }
            },
            getFile (file) {
                const fileList = this.fileList
                let target
                fileList.every(item => {
                    target = file.id === item.id ? item : null
                    return !target
                })
                return target
            },
            upload (file) {
                const _file = this.getFile(file)
                _file.showProgress = true
                this.$emit('on-before-upload', file)
                const formData = new FormData()
                formData.append(this.fileName, file)
                if (this.params) {
                    for (const key in this.params) {
                        formData.append(key, this.params[key])
                    }
                }
                const xhr = new XMLHttpRequest()
                xhr.open('post', this.url, true)
                if (xhr.upload) {
                    xhr.upload.onprogress = e => {
                        if (e.total > 0) {
                            e.percent = e.loaded / e.total * 100
                        }
                        _file.percentage = e.percent || 0
                        this.$emit('on-progress', {
                            file: file,
                            data: e
                        })
                    }
                }
                xhr.onreadystatechange = () => {
                    if (xhr.readyState === 4) {
                        if (parseInt(xhr.status, 10) === 200) {
                            const data = JSON.parse(xhr.responseText)
                            setTimeout(() => {
                                _file.showProgress = false
                            }, 1000)
                            if (data && data.data && data.data.url) {
                                file.url = data.data.url;
                                this.$emit('on-success', {
                                    file: file,
                                    data: data
                                });
                            }

                        } else {
                            const msg = xhr.responseText
                            const err = new Error(msg)
                            err.status = xhr.status
                            err.statusText = xhr.statusText
                            _file.showProgress = false
                            this.fileList.splice(this.fileList.indexOf(_file), 1)
                            this.lastestFile = this.fileList[this.fileList.length - 1]
                            this.$emit('on-error', {
                                file: file,
                                error: err
                            })
                            return
                        }
                    }
                }
                xhr.onerror = e => {
                    _file.showProgress = false
                    this.fileList.splice(this.fileList.indexOf(_file), 1)
                    this.lastestFile = this.fileList[this.fileList.length - 1]
                    this.$emit('on-error', {
                        file: file,
                        error: e
                    })
                }
                if (this.withCredentials && 'withCredentials' in xhr) {
                    xhr.withCredentials = true
                }
                if (this.headers) {
                    for (const header in this.headers) {
                        xhr.setRequestHeader(header, this.headers[header])
                    }
                }
                xhr.send(formData)
            },
            onDeleteFile (file) {
                if (!this.disabled) {
                    const fileList = this.fileList
                    fileList.splice(fileList.indexOf(file), 1)
                    this.lastestFile = fileList[fileList.length - 1]
                    this.$emit('on-delete', file)
                }
            },
            onSetHeadImage(file) {
                if (!this.disabled) {
                    const fileList = this.fileList
                    fileList.splice(fileList.indexOf(file), 1)
                    fileList.unshift(file);
                    this.lastestFile = fileList[fileList.length - 1]
                    this.$emit('on-set-head', file)
                }
            },
            clearFileList () {
                this.fileList = []
            }
        }

    }
</script>



// WEBPACK FOOTER //
// upload.vue?10364cc6